import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { tablerPlayerPauseFilled, tablerPlayerPlayFilled } from '@ng-icons/tabler-icons';
import { NgIconComponent, provideIcons } from '@ng-icons/core';

@Component({
  selector: 'oc-audio-player',
  standalone: true,
  imports: [CommonModule, NgIconComponent],
  providers: [
    provideIcons({
      tablerPlayerPlayFilled,
      tablerPlayerPauseFilled,
    }),
  ],
  template: ` <button class="btn btn-circle btn-outline-primary" type="button" (click)="play()">
    <ng-icon *ngIf="playing" name="tablerPlayerPauseFilled" size="24" color="fff"></ng-icon>
    <ng-icon *ngIf="!playing" name="tablerPlayerPlayFilled" size="24" color="fff"></ng-icon>
  </button>`,
  styles: `
    .btn-circle {
      width: 50px;
      height: 50px;
      border-radius: 999px;
      line-height: 60px;
      padding: 0;
    }
  `,
})
export class AudioPlayerComponent {
  @Input() src: string | null = null;
  @Output() time: EventEmitter<number> = new EventEmitter();

  playing = false;
  started = false;
  audio: InstanceType<typeof Audio> | null = null;

  timeInterval: any | null = null;

  async play() {
    if (this.src) {
      if (this.started) {
        if (this.playing) {
          this.audio?.pause();
          this.playing = false;
        } else {
          this.audio?.play();
          this.playing = true;
        }
      } else {
        this.audio = new Audio(this.src);
        this.audio.addEventListener(
          'ended',
          () => {
            this.playing = false;
            this.started = false;
            this.time.next(0);
            clearTimeout(this.timeInterval);
            this.timeInterval = null;
          },
          false,
        );
        await this.audio.play();
        this.playing = true;
        this.started = true;
        this.timeInterval = setInterval(() => {
          this.time.next(this.audio?.currentTime ?? 0);
        }, 100);
      }
    }
  }
}
